import React, { useEffect, useState } from 'react';
import secretaryPic from "../assets/Ghanshamdasbihani.jpg";
import '../styles/SecretaryMessage.css';

export default function SecretaryMessage() {
    const [isVisible, setIsVisible] = useState(false);
        
          useEffect(() => {
            setIsVisible(true);
          }, []);

  return (
    <div className="secretary-message-wrapper">
      
      {/* Hero Banner with Image */}
      <section className={`sgb-hero-banner ${isVisible ? 'sgb-fade-in' : ''}`}>
        <div className="sgb-hero-overlay">
          <div className="sgb-hero-text-content">
            <h1 className="sgb-hero-main-title">Secretary's Desk</h1>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="secretary-message-content">
        
        {/* Left Side - Photo and Details */}
        <div className="secretary-profile-section">
          <div className="secretary-photo-container">
            <img src={secretaryPic} alt="Secretary" className="secretary-profile-image" />
          </div>
          
          <div className="secretary-profile-details">
            <h2 className="secretary-profile-name">SHRI GHANSHAMDAS JI BINANI</h2>
            <p className="secretary-profile-designation">SECRETARY</p>
            <p className="secretary-profile-organization">SETH. G.L BIHANI S.D. SR. SEC. SCHOOL</p>
          </div>
        </div>

        {/* Right Side - Message */}
        <div className="secretary-message-text-section">
          <p className="secretary-message-paragraph">
            The Upanishad States You Are What Your Deepest Desire Is As Is Your Desire. So Is Your Aspirations. As Is Your Aspiration, So Is Your Action As Is Your Action, So Is Your Destiny. If Hard Work Is Done In The Right Direction With The Right Goal Then It Is Successful. If Your Goal Is Very Clear Then You Will Definitely Get Success. You Are Spending The Most Valuable Time Of Your Life Here. Not Only The School But Also Your Family, Society And Nation Expect You To Be A Competent, Knowledgeable Person A Successful Citizen And An Ideal Inspirational Person. Learned Teachers Computerized Library, Modern Laboratories, Cultural Activities Etc. Are Available For The All Round Development Of Your Personality.
          </p>

          <p className="secretary-message-paragraph">
            A Good School Is Considered Only Where High Qualitative Level Of Education Is Achieved Among The Students. We Meet This Criteria.
          </p>

          <p className="secretary-message-wishes">
            " Best Wishes For A Bright Future "
          </p>
        </div>

      </div>
    </div>
  );
}